import { useGetMulpayOrderEnabledOptIn } from '../useGetMulpayOrderEnabledOptIn';

// メインのユースケースである有効化どうかを確認する場合は、gmo_pg_order_enabledの値だけで良いため、利用しやすいようにhooksを再定義している
export const useIsMulpayOrderEnabled = (
  merchant_public_id: string,
): boolean | undefined => {
  const optInData = useGetMulpayOrderEnabledOptIn(merchant_public_id);

  if (typeof optInData === 'undefined') return undefined;

  return optInData.gmo_pg_order_enabled;
};
